import { render, staticRenderFns } from "./list-customer.vue?vue&type=template&id=29e2a01e"
import script from "./list-customer.vue?vue&type=script&lang=js"
export * from "./list-customer.vue?vue&type=script&lang=js"
import style0 from "./list-customer.vue?vue&type=style&index=0&id=29e2a01e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports